import { gql } from '@apollo/client';

export const GET_BRANDS = gql`
  query brands($filter: BrandFilter!, $where: BrandsWhereFilter) {
    brands(filter: $filter, where: $where) {
      count
      data {
        id
        name
        refData
        primaryColor
        logo {
          url
          key
          name
          extension
          contentType
        }
        uuid
        secondaryColors
        tertiaryColors
        colorPallete
        description
        waiverText
        priceGuarantee
        offerText
        productDetails
        isActive
        createdAt
      }
    }
  }
`;

export const GET_BRAND = gql`
  query brand($id: ID!) {
    brand(where: { id: $id }) {
      id
      name
      uuid
      refData
      primaryColor
      logo {
        url
        key
        name
        extension
        contentType
      }
      secondaryColors
      tertiaryColors
      colorPallete
      description
      waiverText
      priceGuarantee
      offerText
      productDetails
      isActive
      tenantId
    }
  }
`;

export const BRAND_FILTER = gql`
  query brandFilters($filter: BrandFilter!) {
    brandFilters(filter: $filter) {
      count
      data {
        name
        refData
        primaryColor
        logo {
          url
          key
          name
          extension
          contentType
        }
        secondaryColors
        tertiaryColors
        colorPallete
        description
        waiverText
        priceGuarantee
        offerText
        productDetails
        isActive
        tenantId
        createdAt
      }
    }
  }
`;

export const GET_BRAND_LOB = gql`
  query brandLineOfBusinesses($id: ID!) {
    brandLineOfBusinesses(where: { id: $id }) {
      id
      brandId
      lineOfBusinessId
      subAreaIds
      tenantId
      createdAt
      updatedAt
    }
  }
`;

export const GET_LOB_LIST = gql`
  query lineOfBusinesses(
    $filter: LineOfBusinessFilter!
    $where: LineOfBusinessWhereFilter
  ) {
    lineOfBusinesses(filter: $filter, where: $where) {
      count
      data {
        id
        label
        key
        lobCode
        description
        subAreas {
          id
          label
          key
          saCode
          description
          estimation
          isActive
          waiverText
        }
        createdAt
      }
    }
  }
`;
